import React from 'react'
import ITProductsCarouselMain from './ITProductsCarousel/ITProductsCarouselMain'
import LowerBannner from './LowerBanner/LowerBannner'
import LowerLogoCarousel from './LowerLogoCarousel/LowerLogoCarousel'
import LowerProductCarouselMain from './LowerProductCarouselOne/LowerProductCarouselMain'
import LowerSectionLatestProductMain from './LowerSectionLatestProduct/LowerSectionLatestProductMain'
import LowerTimerBanner from './LowerTimerBanner/LowerTimerBanner'
import LowerMap from './Map/LowerMap'


const LowerSection = () => {
  return (
    <>
     <LowerProductCarouselMain/>
     <LowerBannner/>
     <ITProductsCarouselMain/>
     <LowerTimerBanner/>
     <LowerSectionLatestProductMain/>
     <LowerLogoCarousel/>
     <LowerMap/>
    </>
  )
}

export default LowerSection